import { BaseGetRequest } from './core/baseGetRequest';
import { BookingsList, BookingsListDynamicType } from 'acscp/api/models/bookingsList';
import { Authentication } from './core/baseRequest';
import { BookingsFilter } from 'acscp/store';

export class BookingsRequest extends BaseGetRequest<BookingsList> {
    constructor() {
        super(
            'bookingsWithStatus',
            {status: BookingsFilter.Flown, include: 'false'},
            BookingsListDynamicType,
            Authentication.SharingToken,
            'v2'
        );
    }
}
